import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMacbook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconMacbook"><Path d="M3.75 6.25C3.75 4.86929 4.86929 3.75 6.25 3.75H17.75C19.1307 3.75 20.25 4.86929 20.25 6.25V16.75H3.75V6.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><Path d="M1.75 16.75H22.25V17.75C22.25 19.1307 21.1307 20.25 19.75 20.25H4.25C2.86929 20.25 1.75 19.1307 1.75 17.75V16.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconMacbook;
